/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/
import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { apiUtilsReducer, APIUtilsState, API_UTILS_FEATURE_KEY } from './api-utils.reducer';
import { BILLING_PERIODS_STORE_KEY, billingPeriodReducer, BillingPeriodsState } from './billing-periods.reducer';
import { PlanState, PLAN_FEATURE_KEY, planReducer } from './plan.reducer';
import { usersReducer, UsersState, USERS_FEATURE_KEY } from './users.reducer';
import { API_MANAGEMENT_FEATURE_KEY, ApiManagementState, apiManagementReducer } from './api-management.reducer';

export const SHARED_STORE_KEY = 'shared';

export interface SharedState {
  [USERS_FEATURE_KEY]: UsersState;
  [BILLING_PERIODS_STORE_KEY]: BillingPeriodsState;
  [PLAN_FEATURE_KEY]: PlanState;
  [API_UTILS_FEATURE_KEY]: APIUtilsState;
  [API_MANAGEMENT_FEATURE_KEY]: ApiManagementState;
}

export const sharedStateReducerMap: ActionReducerMap<SharedState> = {
  [USERS_FEATURE_KEY]: usersReducer,
  [BILLING_PERIODS_STORE_KEY]: billingPeriodReducer,
  [PLAN_FEATURE_KEY]: planReducer,
  [API_UTILS_FEATURE_KEY]: apiUtilsReducer,
  [API_MANAGEMENT_FEATURE_KEY]: apiManagementReducer,
};

export const getSharedState = createFeatureSelector<SharedState>(SHARED_STORE_KEY);
